<template>
  <div v-if="!$store.getters['user/getUserFields'].is_admin" class="acl-no-access">
    <div class="acl-card">
      <svg class="acl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
      <p>Вы не администратор, авторизируйтесь как администратор</p>
    </div>
  </div>

  <div v-else class="acl-root">
    <!-- Шапка -->
    <div class="acl-header">
      <div class="acl-header-left">
        <h1 class="acl-title">Управление обзвонами</h1>
        <span class="acl-badge">{{ list.length }} активных</span>
      </div>

      <div class="acl-actions">
        <button
          class="acl-btn acl-btn--danger"
          :disabled="stopAllDisabled || !list.length"
          @click="stopAll"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-btn-icon">
            <rect x="6" y="6" width="12" height="12" rx="2"/>
          </svg>
          Остановить все
        </button>

        <button
          v-if="hasStoppedCalls"
          class="acl-btn acl-btn--warning"
          :disabled="resumeAllDisabled"
          @click="resumeAll"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-btn-icon">
            <polygon points="5,3 19,12 5,21"/>
          </svg>
          Возобновить
          <span class="acl-btn-count">{{ stoppedCount }}</span>
        </button>

<button
  v-if="hasStoppedCalls"
  class="acl-btn acl-btn--ghost"
  @click="clearStopped"
>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-btn-icon">
    <polyline points="3,6 5,6 21,6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
  </svg>
  Очистить список
  <span class="acl-btn-count">{{ stoppedCount }}</span>
</button>

        <button
          v-if="list.length"
          class="acl-btn acl-btn--primary"
          @click="showModal = true"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-btn-icon">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          По пользователям
        </button>
      </div>
    </div>

    <!-- Таблица -->
    <div class="acl-table-wrap">
      <div v-if="!list.length" class="acl-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="acl-empty-icon">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
        <p>Нет активных обзвонов</p>
      </div>

      <table v-else class="acl-table">
        <thead>
          <tr>
            <th style="width: 30%">Идентификатор</th>
            <th style="width: 30%">Название</th>
            <th style="width: 20%; cursor: pointer; user-select: none" @click="toggleSort">
              Пользователь
              <span class="acl-sort-arrow">{{ sortAsc ? '&#9650;' : '&#9660;' }}</span>
            </th>
            <th style="width: 20%; text-align: right">Действия</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sortedList" :key="item.key">
            <td class="acl-cell-id">{{ item.key }}</td>
            <td>{{ item.name }}</td>
            <td>
              <span class="acl-user-tag">{{ item.user }}</span>
            </td>
            <td class="acl-cell-actions">
              <button
                class="acl-row-btn acl-row-btn--stop"
                @click="stop(item.key, item.user)"
                title="Остановить"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-row-icon">
                  <rect x="6" y="6" width="12" height="12" rx="2"/>
                </svg>
              </button>
              <button
                class="acl-row-btn acl-row-btn--success"
                @click="success(item.key, item.user)"
                title="Завершить"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="acl-row-icon">
                  <polyline points="20,6 9,17 4,12"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="showModal" class="acl-overlay" @click.self="showModal = false">
      <div class="acl-modal">
        <div class="acl-modal-header">
          <h2>Обзвоны по пользователям</h2>
          <button class="acl-modal-close" @click="showModal = false">&times;</button>
        </div>
        <div class="acl-modal-body">
          <div v-for="(cnt, user) in userStats" :key="user" class="acl-stat-row">
            <span class="acl-stat-user">{{ user }}</span>
            <span class="acl-stat-count">{{ cnt }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      hasStoppedCalls: false,
      stoppedCount: 0,
      stopAllDisabled: false,
      resumeAllDisabled: false,
      sortAsc: true,
      showModal: false
    };
  },
  computed: {
    sortedList() {
      return [...this.list].sort((a, b) =>
        this.sortAsc ? a.user.localeCompare(b.user) : b.user.localeCompare(a.user)
      );
    },
    userStats() {
      return this.list.reduce((acc, { user }) => {
        acc[user] = (acc[user] || 0) + 1;
        return acc;
      }, {});
    }
  },
  methods: {
    getAll() {
      this.$http.post('/list_calls/all', {}, (result) => {
        this.list = result;
      });
    },
    checkStoppedCalls() {
      this.$http.post('/list_calls/checkStopped', {}, (resp) => {
        this.hasStoppedCalls = resp && resp.hasStopped;
        this.stoppedCount = (resp && resp.count) || 0;
      });
    },
    stop(call_id, user) {
      this.$http.post('/list_calls/stop', { call_id, user }, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    success(call_id, user) {
      this.$http.post('/list_calls/success', { call_id, user }, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    stopAll() {
      this.stopAllDisabled = true;
      setTimeout(() => { this.stopAllDisabled = false; }, 15000);

      this.$http.post('/list_calls/stopAll', {}, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
    resumeAll() {
      this.resumeAllDisabled = true;
      setTimeout(() => { this.resumeAllDisabled = false; }, 15000);

      this.$http.post('/list_calls/resumeAll', {}, () => {
        this.getAll();
        this.checkStoppedCalls();
      });
    },
clearStopped() {
  if (!confirm(`Очистить список остановленных? (${this.stoppedCount} шт.) Эти обзвоны нельзя будет возобновить кнопкой.`)) {
    return;
  }
  this.$http.post('/list_calls/clearStopped', {}, () => {
    this.hasStoppedCalls = false;
    this.stoppedCount = 0;
  });
},
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    }
  },
  mounted() {
    this.getAll();
    this.checkStoppedCalls();
  }
};
</script>

<style scoped>
/* ====== Root ====== */
.acl-root {
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #1a1a2e;
}

.acl-no-access {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.acl-card {
  text-align: center;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
}
.acl-icon {
  width: 48px;
  height: 48px;
  color: #94a3b8;
  margin-bottom: 12px;
}

.acl-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}
.acl-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.acl-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
}
.acl-badge {
  display: inline-flex;
  align-items: center;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.acl-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.acl-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.acl-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.acl-btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.acl-btn--danger {
  background: #fee2e2;
  color: #dc2626;
}
.acl-btn--danger:hover:not(:disabled) {
  background: #dc2626;
  color: #fff;
}

.acl-btn--warning {
  background: #fff7ed;
  color: #ea580c;
}
.acl-btn--warning:hover:not(:disabled) {
  background: #ea580c;
  color: #fff;
}

.acl-btn--ghost {
  background: #f1f5f9;
  color: #64748b;
}
.acl-btn--ghost:hover:not(:disabled) {
  background: #e2e8f0;
  color: #334155;
}

.acl-btn--primary {
  background: #eff6ff;
  color: #2563eb;
}
.acl-btn--primary:hover:not(:disabled) {
  background: #2563eb;
  color: #fff;
}

.acl-btn-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  background: rgba(0,0,0,.1);
  border-radius: 10px;
  font-size: 11px;
  padding: 0 5px;
}
.acl-btn--warning:hover:not(:disabled) .acl-btn-count {
  background: rgba(255,255,255,.25);
}

.acl-table-wrap {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04);
  overflow: hidden;
}

.acl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.acl-table thead {
  background: #f8fafc;
}
.acl-table th {
  text-align: left;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
}
.acl-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.acl-table tbody tr:hover {
  background: #f8fafc;
}
.acl-table tbody tr:last-child td {
  border-bottom: none;
}

.acl-sort-arrow {
  font-size: 10px;
  margin-left: 4px;
  color: #94a3b8;
}

.acl-cell-id {
  font-family: 'SF Mono', SFMono-Regular, Consolas, monospace;
  font-size: 12px;
  color: #64748b;
}

.acl-user-tag {
  display: inline-flex;
  background: #f1f5f9;
  color: #475569;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.acl-cell-actions {
  text-align: right;
}

.acl-row-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-left: 4px;
  transition: all 0.15s ease;
}
.acl-row-icon {
  width: 16px;
  height: 16px;
}

.acl-row-btn--stop {
  background: #fef2f2;
  color: #ef4444;
}
.acl-row-btn--stop:hover {
  background: #ef4444;
  color: #fff;
}

.acl-row-btn--success {
  background: #f0fdf4;
  color: #22c55e;
}
.acl-row-btn--success:hover {
  background: #22c55e;
  color: #fff;
}

.acl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  color: #94a3b8;
}
.acl-empty-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
}
.acl-empty p {
  font-size: 15px;
  margin: 0;
}

.acl-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.acl-modal {
  background: #fff;
  border-radius: 14px;
  width: 90%;
  max-width: 380px;
  box-shadow: 0 20px 60px rgba(0,0,0,.2);
  overflow: hidden;
}
.acl-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.acl-modal-header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}
.acl-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.acl-modal-close:hover {
  color: #1a1a2e;
}
.acl-modal-body {
  padding: 16px 20px;
  max-height: 400px;
  overflow-y: auto;
}
.acl-stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f8fafc;
}
.acl-stat-row:last-child {
  border-bottom: none;
}
.acl-stat-user {
  font-weight: 500;
  font-size: 14px;
}
.acl-stat-count {
  background: #eff6ff;
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 12px;
}
</style>